export const preloadImages = (sources?: string | string[]) => {
    if (!sources || sources.length < 1) {
        return;
    }

    if (typeof sources === "string") {
        const image = new Image();
        image.src = sources;

        return;
    }

    const images = [];

    for (let i = 0; i < sources.length; i++) {
        images[i] = new Image();
        images[i].src = sources[i];
    }
};
